import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';

/**
 * This is a modified version of the `usePersistentData` hook
 * that uses session storage instead of persistent local storage
 */
export function useSessionData<T>(key: string) {
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery([key], () => sessionStorage.getItem(key), {
    initialData: sessionStorage.getItem(key),
  });

  const { mutateAsync: setData } = useMutation(async (data: T) => sessionStorage.setItem(key, JSON.stringify(data)), {
    onMutate: (mutatedData: T) => {
      const current = data;
      queryClient.setQueryData([key], JSON.stringify(mutatedData));
      return current;
    },
    onError: (_: unknown, __: unknown, rollback: any) => {
      queryClient.setQueryData([key], rollback);
    },
  });

  return { data, setData, isLoading };
}
